<div *ngIf="true">

  <div *ngIf="!isSPOEEnabled" class="access-codes my-2" style="text-align:center;padding:10px;">
    <adp-label labelKey="LookupUser_ReviewAddress_Verify_ConfirmInstruction"></adp-label>
  </div>
  <div *ngIf="isSPOEEnabled" class="access-codes my-2" style="text-align:left;padding-top:10px;">
    <adp-label labelKey="SPOE_LookupUser_ReviewAddress_Verify_ConfirmInstruction"></adp-label>
  </div>

  <div class="access-codes my-2" *ngIf="isSPOEEnabled">
    <div fxLayout="row" class="mb-3 pt-3 row-item">
      <adp-label class="fw-600" style="font-size: 18px;" labelKey="LookupUser_ReviewContact_Text_Mobile_Number"></adp-label>
      <a href="javascript:void(0);" (click)="onEdit()" class="edit-button" fxLayout="row">
        <mat-icon [class]="'adp-ds-icon-wrapper'" svgIcon="edit"></mat-icon>
        <div class="ml-5">EDIT</div>
      </a>
    </div>
    <p class="mt-1 mb-1">{{formattedPhoneNumber}}</p>
  </div>

  <div class="access-codes my-2" style="text-align:left;padding-top:10px;" *ngIf="isSPOEEnabled">
    <adp-label labelKey="SPOE_LookupUser_ReviewAddress_Verify_Title"></adp-label>
  </div>

  <div class="access-codes my-2 pb-3">
    <div fxLayout="row" class="mb-3 pt-3 row-item">
      <adp-label class="fw-600" style="font-size: 18px;" labelKey="LookupUser_ReviewAddress_Verify_TitleText"></adp-label>
      <a href="javascript:void(0);" (click)="onEdit()" class="edit-button" fxLayout="row">
        <mat-icon [class]="'adp-ds-icon-wrapper'" svgIcon="edit"></mat-icon>
        <div class="ml-5">EDIT</div>
      </a>
    </div>
    <p class="mt-1 mb-1">{{contactInfo.addressLine1}} {{contactInfo.addressLine2}}</p>
    <p class="mt-1 mb-1">{{contactInfo.city}}, {{contactInfo.state}} {{contactInfo.zipCode}}</p>
  </div>
  <div class="form-group mt-4 mb-3">
    <button mat-flat-button class="next-btn" color="accent" (click)="confirm()">
      <adp-label labelKey="Global_Button_Confirm"></adp-label>
    </button>
  </div>
</div>
